import React from "react";

export default function ContactCard({ title, description, description2, icon }) {
  const isEmail = (value) => typeof value === "string" && value.includes("@");
  const isPhone = (value) => typeof value === "string" && value.match(/\d{3,}/);

  const renderValue = (value) => {
    if (!value) return null;

    if (typeof value !== "string") return value;

    if (isEmail(value)) {
      return (
        <a
          href={`mailto:${value}`}
          className="text-neutral-600 hover:text-blue-400 transition group-hover:text-white"
        >
          {value}
        </a>
      );
    }

    if (isPhone(value)) {
      return (
        <a
          href={`tel:${value}`}
          className="text-neutral-600 hover:text-red-400 transition font-semibold group-hover:text-white"
        >
          {value}
        </a>
      );
    }

    return <span className="text-gray-600 group-hover:text-white">{value}</span>;
  };

  return (
    <div className="relative bg-white p-8 h-full rounded-xl group transition-all duration-300 cursor-pointer hover:bg-neutral-800 hover:shadow-xl">
      {/* Ícono de fondo */}
      <div className="absolute top-6 left-1/2 transform -translate-x-1/2 text-gray-400 text-[8rem] transition-colors duration-300 group-hover:text-red-600 opacity-20 pointer-events-none">
        {icon}
      </div>

      {/* Título */}
      <h3 className="uppercase text-center text-2xl text-gray-800 font-extrabold tracking-wide relative z-10 group-hover:text-white">
        {title}
      </h3>

      <div className="h-0.5 bg-gray-300 mx-auto mt-3 relative z-10 w-full group-hover:bg-red-600 transition-all duration-300"></div>

      {/* Descripciones */}
      <div className="mt-5 space-y-2 text-center relative z-10 text-lg font-medium">
        {renderValue(description)} <br />
        {renderValue(description2)}
      </div>
    </div>
  );
}
